"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.includes.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _isHotkey = _interopRequireDefault(require("is-hotkey"));

var _slateReact = require("slate-react");

var _slate = require("slate");

var _slateHistory = require("slate-history");

var _css = require("@emotion/css");

var _RichTextEditorModule = _interopRequireDefault(require("../../assets/styles/components/RichTextEditor.module.scss"));

var _DesignSystem = _interopRequireDefault(require("../../assets/styles/DesignSystem.json"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

const _excluded = ["className", "active", "reversed"],
      _excluded2 = ["className"],
      _excluded3 = ["className"],
      _excluded4 = ["className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const HOTKEYS = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline",
  "mod+`": "code"
};
const LIST_TYPES = ["numbered-list", "bulleted-list"];

const Button = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    className,
    active,
    reversed
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: " \n        ".concat(active ? _RichTextEditorModule.default.active_icon : _RichTextEditorModule.default.inactive_icon, "  \n\n        ").concat((0, _css.cx)(className, (0, _css.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          cursor: pointer;\n        "])))), "\n      ")
  }));
});

const Icon = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    className
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: (0, _css.cx)("material-icons", className, (0, _css.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        font-size: 18px;\n        vertical-align: text-bottom;\n      "]))))
  }));
});

const Menu = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    className
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: (0, _css.cx)(className, (0, _css.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        & > * {\n          display: inline-block;\n        }\n\n        & > * + * {\n          margin-left: 15px;\n        }\n      "]))))
  }));
});

const Toolbar = /*#__PURE__*/_react.default.forwardRef((_ref4, ref) => {
  let {
    className
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Menu, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: "\n      ".concat(_RichTextEditorModule.default.menu, "\n      ").concat((0, _css.cx)(className, (0, _css.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        position: relative;\n        padding: 1px 18px 17px;\n        margin: 0 -20px;\n        border-bottom: 2px solid;\n        border-color: red;\n        margin-bottom: 20px;"])))), "\n    ")
  }));
});

const toggleBlock = (editor, format) => {
  const isActive = isBlockActive(editor, format);
  const isList = LIST_TYPES.includes(format);

  _slate.Transforms.unwrapNodes(editor, {
    match: n => LIST_TYPES.includes(n.type),
    split: true
  });

  _slate.Transforms.setNodes(editor, {
    type: isActive ? "paragraph" : isList ? "list-item" : format
  });

  if (!isActive && isList) {
    const block = {
      type: format,
      children: []
    };

    _slate.Transforms.wrapNodes(editor, block);
  }
};

const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    _slate.Editor.removeMark(editor, format);
  } else {
    _slate.Editor.addMark(editor, format, true);
  }
};

const isBlockActive = (editor, format) => {
  const [match] = _slate.Editor.nodes(editor, {
    match: n => n.type === format
  });

  return !!match;
};

const isMarkActive = (editor, format) => {
  const marks = _slate.Editor.marks(editor);

  return marks ? marks[format] === true : false;
};

const Element = _ref5 => {
  let {
    attributes,
    children,
    element
  } = _ref5;

  switch (element.type) {
    case "block-quote":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("blockquote", _objectSpread(_objectSpread({}, attributes), {}, {
        children: children
      }));

    case "bulleted-list":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", _objectSpread(_objectSpread({}, attributes), {}, {
        children: children
      }));

    case "heading-one":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", _objectSpread(_objectSpread({}, attributes), {}, {
        children: children
      }));

    case "heading-two":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", _objectSpread(_objectSpread({}, attributes), {}, {
        children: children
      }));

    case "list-item":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", _objectSpread(_objectSpread({}, attributes), {}, {
        children: children
      }));

    case "numbered-list":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("ol", _objectSpread(_objectSpread({}, attributes), {}, {
        children: children
      }));

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", _objectSpread(_objectSpread({}, attributes), {}, {
        children: children
      }));
  }
};

const Leaf = _ref6 => {
  let {
    attributes,
    children,
    leaf
  } = _ref6;

  if (leaf.bold) {
    children = /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
      children: children
    });
  }

  if (leaf.code) {
    children = /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
      children: children
    });
  }

  if (leaf.italic) {
    children = /*#__PURE__*/(0, _jsxRuntime.jsx)("em", {
      children: children
    });
  }

  if (leaf.underline) {
    children = /*#__PURE__*/(0, _jsxRuntime.jsx)("u", {
      children: children
    });
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, attributes), {}, {
    children: children
  }));
};

const BlockButton = _ref7 => {
  let {
    format,
    icon
  } = _ref7;
  const editor = (0, _slateReact.useSlate)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
    active: isBlockActive(editor, format),
    onMouseDown: event => {
      event.preventDefault();
      toggleBlock(editor, format);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      children: icon
    })
  });
};

const MarkButton = _ref8 => {
  let {
    format,
    icon
  } = _ref8;
  const editor = (0, _slateReact.useSlate)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
    active: isMarkActive(editor, format),
    onMouseDown: event => {
      event.preventDefault();
      toggleMark(editor, format);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      children: icon
    })
  });
};

const initialValue = [{
  type: "paragraph",
  children: [{
    text: "Hello!"
  }]
}];

const RichTextEditor = _ref9 => {
  let {
    onChangeText,
    placeholder,
    defaultValue = null,
    showSettings = true,
    readOnly = false
  } = _ref9;
  const [value_state, setValue] = (0, _react.useState)(defaultValue ? defaultValue : initialValue);
  const renderElement = (0, _react.useCallback)(props => /*#__PURE__*/(0, _jsxRuntime.jsx)(Element, _objectSpread({}, props)), []);
  const renderLeaf = (0, _react.useCallback)(props => /*#__PURE__*/(0, _jsxRuntime.jsx)(Leaf, _objectSpread({}, props)), []);
  const editor = (0, _react.useMemo)(() => (0, _slateHistory.withHistory)((0, _slateReact.withReact)((0, _slate.createEditor)())), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _RichTextEditorModule.default.richtexteditor,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
      rel: "stylesheet",
      href: "https://fonts.googleapis.com/icon?family=Material+Icons"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_slateReact.Slate, {
      editor: editor,
      value: value_state,
      onChange: value => {
        setValue(value);
        onChangeText(value);
      },
      children: [showSettings && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Toolbar, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MarkButton, {
          format: "bold",
          icon: "format_bold"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MarkButton, {
          format: "italic",
          icon: "format_italic"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MarkButton, {
          format: "underline",
          icon: "format_underlined"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MarkButton, {
          format: "code",
          icon: "code"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(BlockButton, {
          format: "heading-one",
          icon: "looks_one"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(BlockButton, {
          format: "heading-two",
          icon: "looks_two"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(BlockButton, {
          format: "block-quote",
          icon: "format_quote"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(BlockButton, {
          format: "numbered-list",
          icon: "format_list_numbered"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(BlockButton, {
          format: "bulleted-list",
          icon: "format_list_bulleted"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_slateReact.Editable, {
        readOnly: readOnly,
        renderElement: renderElement,
        renderLeaf: renderLeaf,
        placeholder: placeholder,
        spellCheck: true,
        autoFocus: true,
        onKeyDown: event => {
          for (const hotkey in HOTKEYS) {
            if ((0, _isHotkey.default)(hotkey, event)) {
              event.preventDefault();
              const mark = HOTKEYS[hotkey];
              toggleMark(editor, mark);
            }
          }
        }
      })]
    })]
  });
};

var _default = RichTextEditor;
exports.default = _default;